import UserFavorites from "view3/UserFavorites.js";

import connectFunction from "redux/connectFunction";

function mapStateToProps(state) {
  return {
    categories: state.categories,
    alert: state.alert,
    user: state.user,
    attributes: state.attributes,
    language: state.language
  };
}

const UserFavoritesContainer = connectFunction(mapStateToProps)(UserFavorites);
export default UserFavoritesContainer;
